import React, {useContext} from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { LawyerContext } from '../../../../partials/Context';

const animatedComponents = makeAnimated();

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    padding: '5px',
    fontSize: '0.85rem',
    
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: '100%',
    display: 'flex',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    fontSize: '0.85rem',
    alignItems: 'center',
  }),
  menuPortal: base => ({...base, zIndex: 999})
}

function AnimatedMulti(props) {
    const {options, handleChosen} = props
    return (
        <Select 
            closeMenuOnSelect={false}
            components={animatedComponents}
            isMulti
            options={options}
            onChange={handleChosen}
            menuPortalTarget={document.body}
            styles={customStyles}
            placeholder={'wybierz kategorię'}
        />
    )
}

function Filter(props) {
    const {handleChosen, handleUnread} = props
    const lawyer = useContext(LawyerContext);
    const {categories} = lawyer;
    let options = [];
    
    if(categories)
    categories.map((item) => {
        return options.push(
            {'value': item.slug, 'label': item.name, 'id': item.id}
        )
    })

    return (
        <fieldset>
                <legend className="search-title">Filtruj</legend>
                <hr />
                <div className="form-group">
                    <label><b>Po kategoriach</b></label>

                    <div className="form-group">
                        <AnimatedMulti 
                            options={options}
                            handleChosen={handleChosen}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <div className="checkbox">
                        <label>
                            <input type="checkbox" onChange={handleUnread}/> Pokaż <strong>tylko</strong> nieprzeczytane
                        </label>
                    </div>
                </div>
            </fieldset>
    )
}

export default Filter;